// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green-checkbox .ant-checkbox-checked .ant-checkbox-inner {
  background-color: green !important;
  border-color: green !important;
}

.green-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: white !important; /* Change this if you want a different tick color */
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/pages/Admin/CartViewPage.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B,EAAE,mDAAmD;AACrF","sourcesContent":[".green-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: green !important;\n  border-color: green !important;\n}\n\n.green-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: white !important; /* Change this if you want a different tick color */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
